import { useQuery } from '@tanstack/react-query';
import { fetchAnalyticsCompanies } from '@/utils/analyticsCompaniesAPI';
import type { CompanyAggregateRequest, CompanyAggregateResponse } from '@/components/reports/lists/types';

export function useAnalyticsCompanies(
  config: Omit<CompanyAggregateRequest, 'pagination'> | null,
  offset: number = 0
) {
  return useQuery<CompanyAggregateResponse, Error>({
    queryKey: ['analytics-companies', config, offset],
    queryFn: () => {
      if (!config) throw new Error('Configuration required');

      return fetchAnalyticsCompanies({
        ...config,
        pagination: {
          limit: 100,  // Use max limit for company aggregates
          offset,
        }
      });
    },
    enabled: !!config && (!!config.period || !!config.periods),
    staleTime: 5 * 60 * 1000,  // 5 minutes
    gcTime: 30 * 60 * 1000,    // 30 minutes (formerly cacheTime)
    retry: 2,
  });
}
